import Chart, { type ChartType, type ChartTypeRegistry } from 'chart.js/auto';

window.Webflow ||= [];
window.Webflow.push(() => {
  const dataMap = loadResult();

  if (!dataMap) {
    return;
  }

  replaceValues(dataMap);

  loadCharts(dataMap);
});

function loadResult(): { [key: string]: number } | null {
  const dataString = localStorage.getItem('latestResult');
  if (!dataString) {
    window.location.href = 'https://smart-leadership-test.webflow.io/team-performance-assessment';
    return null;
  }
  return JSON.parse(dataString);
}

function getColorForValue(value: number): string {
  if (value < 0.25) return 'red';
  if (value < 0.5) return 'orange';
  if (value < 0.75) return '#B4C424';
  return 'green';
}

function replaceValues(dataMap: { [key: string]: number }) {
  const valueIndicator: string = 'kw-tpa-result-placeholder';

  const elementsToReplace: NodeListOf<HTMLElement> = document.querySelectorAll(
    `[${valueIndicator}]`
  );

  elementsToReplace.forEach((element: HTMLElement) => {
    const value = element.getAttribute(valueIndicator);
    if (!value) {
      return;
    }
    element.innerHTML = Math.round(dataMap[value] * 100) + '%';
    element.style.color = getColorForValue(dataMap[value]);
  });
}

async function loadCharts(dataMap: { [key: string]: number }) {
  console.log(dataMap);

  loadChart(
    [
      dataMap['Leistungsdimension (Execution)'] * 100,
      dataMap['Soziale Dimension (Engagement)'] * 100,
      dataMap['Entwicklungsdimension (Enhancement)'] * 100,
    ],
    ['Execution', 'Engagement', 'Enhancement'],
    'chart-1',
    'radar'
  );

  loadChart(
    [
      dataMap['Wissen der Teammitglieder'] * 100,
      dataMap['Können der Teammitglieder'] * 100,
      dataMap['Wollen der Teammitglieder'] * 100,
    ],
    ['Wissen', 'Können', 'Wollen'],
    'chart-2',
    'radar'
  );

  loadChart(
    [dataMap['Individuum'] * 100, dataMap['Team'] * 100, dataMap['Organisation'] * 100],
    ['Individuelle Ebene', 'Team-Ebene', 'Organisationale Ebene'],
    'chart-3',
    'radar'
  );

  loadChart(
    [
      dataMap['Wissen: Ziele'] * 100,
      dataMap['Wissen: Rollen'] * 100,
      dataMap['Wissen: Prozesse (Spielregeln)'] * 100,
      dataMap['Können: Ziele'] * 100,
      dataMap['Können: Rollen'] * 100,
      dataMap['Können: Prozesse (Spielregeln)'] * 100,
      dataMap['Wollen: Ziele'] * 100,
      dataMap['Wollen: Rollen'] * 100,
      dataMap['Wollen: Prozesse (Spielregeln)'] * 100,
    ],
    [
      'Wissen: Ziele',
      'Wissen: Rollen',
      'Wissen: Prozesse (Spielregeln)',
      'Können: Ziele',
      'Können: Rollen',
      'Können: Prozesse (Spielregeln)',
      'Wollen: Ziele',
      'Wollen: Rollen',
      'Wollen: Prozesse (Spielregeln)',
    ],
    'chart-4',
    'bar'
  );

  loadChart(
    [
      dataMap['Wissen: Sensing'] * 100,
      dataMap['Wissen: Seizing'] * 100,
      dataMap['Wissen: Reconfiguring'] * 100,
      dataMap['Können: Sensing'] * 100,
      dataMap['Können: Seizing'] * 100,
      dataMap['Können: Reconfiguring'] * 100,
      dataMap['Wollen: Sensing'] * 100,
      dataMap['Wollen: Seizing'] * 100,
      dataMap['Wollen: Reconfiguring'] * 100,
    ],
    [
      'Wissen: Sensing',
      'Wissen: Seizing',
      'Wissen: Reconfiguring',
      'Können: Sensing',
      'Können: Seizing',
      'Können: Reconfiguring',
      'Wollen: Sensing',
      'Wollen: Seizing',
      'Wollen: Reconfiguring',
    ],
    'chart-5',
    'bar'
  );
}

function loadChart(data: number[], labels: string[], identifier: string, type: ChartType) {
  const ctx = document.querySelector<HTMLCanvasElement>(`[data-element="${identifier}"]`);

  if (!ctx) {
    return;
  }

  let backgroundColor;
  if (type === 'radar') {
    backgroundColor = ['rgba(242, 234, 0, 0.3)'];
  } else {
    backgroundColor = [
      'rgba(242, 234, 0, 0.4)',
      'rgba(242, 234, 0, 0.7)',
      'rgba(242, 234, 0, 1)',
      'rgba(16, 24, 40, 0.4)',
      'rgba(16, 24, 40, 0.7)',
      'rgba(16, 24, 40, 1)',
      'rgba(224, 79, 22, 0.4)',
      'rgba(224, 79, 22, 0.7)',
      'rgba(224, 79, 22, 1)',
    ];
  }

  new Chart(ctx, {
    type: type,
    data: {
      labels: labels,
      datasets: [
        {
          label: 'Ergebnis',
          data: data,
          fill: true,
          backgroundColor: backgroundColor,
          borderColor: 'rgb(242, 234, 0)',
          pointBackgroundColor: 'rgb(54, 54, 54)',
        },
      ],
    },
    options: {
      elements: {
        line: {
          borderWidth: 5,
        },
      },
      scales: {
        r: {
          suggestedMin: 0,
          suggestedMax: 100,
        },
      },
      plugins: {
        legend: {
          display: false,
          position: 'top',
        },
        tooltip: {
          enabled: true,
          mode: 'nearest',
          intersect: false,
        },
      },
      animation: {
        duration: 1000,
        easing: 'easeOutSine',
      },
    },
  });
}
